<script setup lang="ts">
withDefaults(
  defineProps<{
    tip: string
    position?: 'top' | 'bottom' | 'left' | 'right'
    fit?: boolean
  }>(),
  { position: 'top', fit: false }
)
</script>

<template>
  <div
    :class="['tooltip', 'tooltip-' + position, fit ? 'w-fit' : 'w-full']"
    :data-tip="tip"
  >
    <slot />
  </div>
</template>
